import React, { useEffect, useState } from "react";
import { Modal, Button, message } from "antd";
import { useFormik } from "formik";
import * as Yup from "yup";
import axios from "axios";
import Cookies from "js-cookie";
import { BASE_URL_TWO } from "../../../../utils";
import { Grid } from "@mui/material";

// Validation schema for form fields
const validationSchema = Yup.object().shape({
    visaType: Yup.string().required("Visa Type is required"),
});

export default function VisaAdd({ visible, onClose, setShouldRefetch, shouldRefetch }) {
    const id = Cookies.get("userId");
    const token = Cookies.get("token");

    const headers = {
        token: token,
        "Content-Type": "application/json",
    };

    const showMessage = () => {
        message.success({
            content: "Added Visa Type",
            duration: 1,
        });
    };

    const initialValues = {
        visaType: "",
    };

    const formik = useFormik({
        initialValues,
        validationSchema,
        validateOnChange: false,
        validateOnBlur: false,
        onSubmit: async (values, { resetForm }) => {
            try {
                // Submit the form data to add the visa type
                await axios.post(`${BASE_URL_TWO}`, {
                    sp: "insVisaType",
                    visaTypeName: values?.visaType,
                });

                showMessage();
                setShouldRefetch(!shouldRefetch); // Trigger refetch
                resetForm(); // Reset the form to initial values
                onClose(); // Close the modal
            } catch (error) {
                message.error("Failed to add visa type");
                console.error(error);
            }
        },
    });

    const handleClose = ()=>{
        formik.resetForm();
        onClose();
    }

    return (
        <Modal
            title="Enter Visa Type"
            visible={visible}
            onCancel={handleClose}
            footer={null}
            destroyOnClose
            centered
            width={600} // Adjust modal width if needed
            className="custom-modal-header p-0"
            maskClosable={false}
        >
            <form onSubmit={formik.handleSubmit}>
                {/* Visa Type Field */}
                <div className="row mb-3">
                    <label className="col-lg-3 col-form-label fw-bold fs-7">Visa Type <span className="text-danger">*</span></label>
                    <div className="col-lg-9">
                        <input
                            type="text"
                            className="form-control form-control-lg form-control-solid"
                            placeholder="Enter visa type"
                            name="visaType"
                            value={formik.values.visaType}
                            onChange={formik.handleChange}
                        />
                        <span style={{ fontSize: "10px", color: "red" }}>{formik.errors.visaType}</span>
                    </div>
                </div>

                {/* Submit Button */}
                <Grid container justifyContent="end">
                    <button type="submit" className="btn btn-lg btn-primary mt-5">
                        <div style={{ display: "flex", alignItems: "center" }}>
                            <span className="indicator-label">Add Visa Type</span>
                        </div>
                    </button>
                </Grid>
            </form>
        </Modal>
    );
}
